// extracted by mini-css-extract-plugin
export var character = "Donate-module--character--XFKlF";
export var compact = "Donate-module--compact--Hdlt6";
export var donate = "Donate-module--donate--XPwkg";
export var root = "Donate-module--root--Ix9qf";
export var text = "Donate-module--text--zin97";